import { Phone } from 'lucide-react';

export const ClickToCall = () => {
  return (
    <a 
      href="tel:+13233780061" 
      className="click-to-call md:hidden"
      data-testid="click-to-call"
      aria-label="Call Gomez Cleaning Service"
    >
      <Phone size={24} />
    </a>
  );
};

export default ClickToCall;
